import React from 'react';
import { Stepper, Step, StepLabel, SxProps, Theme } from '@mui/material';

interface StepWizardProps {
  steps: string[];
  activeStep: number;
  alternativeLabel?: boolean;
  sx?: SxProps<Theme>;
}

const StepWizard: React.FC<StepWizardProps> = ({
  steps,
  activeStep,
  alternativeLabel = false,
  sx,
}) => {
  return (
    <Stepper activeStep={activeStep} sx={sx} alternativeLabel={alternativeLabel}>
      {steps.map((label, index) => (
        <Step key={label} completed={activeStep > index}>
          <StepLabel>{label}</StepLabel>
        </Step>
      ))}
    </Stepper>
  );
};

export default StepWizard;
